import styled, { withTheme } from 'styled-components';
import { connect } from 'react-redux';
import { rem } from 'polished';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Loader from '../Loader/index';
import BusLayout from './busLayout';
import InformationMessage from '../InformationMessage/index';
import { __ } from '../../utilities';

import { fetchBus } from './actions';

import { seatingLayoutSelector, seatingsIsFetchingSelector } from './selectors';

const Wrapper = styled.div`
  color: ${({ theme }) => theme.color.font.primary};
  font-size: ${rem(14)};
  padding: ${rem(20)};
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const Title = styled.div`
  margin-top: ${rem(20)};
`;

class Bus extends Component {
  constructor(props) {
    super(props);
    this.getData = this.getData.bind(this);
  }

  componentDidMount() {
    this.getData();
    this.interval = setInterval(() => {
      this.getData();
    }, 100000); // cas medzi updatom dat - momentalne nastaveny na 100 000ms - neskor na stanovu dobre refreshu v.
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  getData() {
    this.props.dispatch(
      fetchBus(this.props.fromId, this.props.toId, this.props.busId),
    );
  }

  render() {
    if (!this.props.displayed) {
      return <div />;
    }
    if (!this.props.isFetching && this.props.layout.length === 0) {
      return (
        <InformationMessage
          type="warning"
          title={__('Pre tento smer nie je možné vyberať miestenky')}
        />
      );
    }
    return this.props.isFetching ? (
      <Wrapper>
        <Loader size="xl" color="#b90834" />
        <Title> {__('Načítavam... ')} </Title>
      </Wrapper>
    ) : (
      <BusLayout
        layout={this.props.layout}
        selectSeat={this.props.selectSeat}
        selectedSeats={this.props.selectedSeats}
      />
    );
  }
}

Bus.propTypes = {
  displayed: PropTypes.bool,
  busId: PropTypes.number,
  selectedSeats: PropTypes.arrayOf(PropTypes.number),
  fromId: PropTypes.number,
  toId: PropTypes.number,
  selectSeat: PropTypes.func,
  dispatch: PropTypes.func.isRequired,
  isFetching: PropTypes.bool.isRequired,
  layout: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

Bus.defaultProps = {
  displayed: false,
  busId: 0,
  selectedSeats: [],
  fromId: 0,
  toId: 0,
  selectSeat: () => {},
};

const mapStateToProps = (state, props) => {
  return {
    layout: seatingLayoutSelector(props.busId)(state),
    isFetching: seatingsIsFetchingSelector(state),
  };
};

const StyledBuss = withTheme(Bus);
export default connect(mapStateToProps)(StyledBuss);



// WEBPACK FOOTER //
// ./src/components/Bus/index.js